export const STATUS_CONFIG = {
  New:             { label: 'New',           color: '#64748b', bg: '#f1f5f9' },
  InProgress:      { label: 'In Progress',   color: '#4f46e5', bg: '#eef2ff' },
  OnHold:          { label: 'On Hold',       color: '#d97706', bg: '#fffbeb' },
  CompletedByUser: { label: 'Completed',     color: '#059669', bg: '#ecfdf5' },
  DoneByAdmin:     { label: 'Done',          color: '#7c3aed', bg: '#f5f3ff' },
};
export const STATUS_OPTIONS = Object.keys(STATUS_CONFIG);
export const ROLE_OPTIONS   = ['Admin', 'Manager', 'User'];
export const APPROVAL_CONFIG = {
  Pending:  { color: '#d97706', bg: '#fffbeb' },
  Approved: { color: '#059669', bg: '#ecfdf5' },
  Rejected: { color: '#dc2626', bg: '#fef2f2' },
};
